/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@saviynt/design-system';

import { type FieldTypes } from '../Form/FormBuilder';

export interface ToggleButtonOption {
  label: string;
  value: string;
}

export interface ToggleGroupField {
  type: FieldTypes | null;
  options: ToggleButtonOption[];
  visibleCount?: number;
  selection?: number;
  setSelection?: (index: number) => void;
  onSelectionChange?: (index: number, option: ToggleButtonOption) => void;
  size?: 'small' | 'medium' | 'large';
  isPill?: boolean;
  isDisabled?: boolean;
  className?: string;
  dataTestId?: string;
  required?: boolean;
  payloadAtrributeName: string;
  attributeName: string;
  label: string;
  fieldDisabled?: boolean;
  attributeKey?: string;
  inputValueStatus: (status: {
    attributeName: string;
    value: string;
    hasError: boolean;
    payloadAtrributeName: string;
  }) => void;
}

/**
 * toggle group
 */
function FormToggleGroup({
  label,
  options,
  attributeName,
  fieldDisabled = false,
  inputValueStatus,
  selection,
  setSelection,
  // eslint-disable-next-line no-unused-vars
  ...rest
}: ToggleGroupField) {
  const handleChange = (index: number) => {
    setSelection?.(index);

    const arrayIndex = index - 1;
    const selectedOption = options[arrayIndex];

    inputValueStatus({
      attributeName,
      value: selectedOption.value,
      hasError: false,
      payloadAtrributeName: attributeName,
    });
  };

  return (
    <Box>
      {label && (
        <label htmlFor={attributeName} style={{ fontWeight: 500 }}>
          {label}
        </label>
      )}
      <ToggleButtonGroup selection={selection} setSelection={handleChange}>
        {options.map((opt) => (
          <ToggleButton
            key={opt.value}
            label={opt.label}
            isDisabled={fieldDisabled}
            dataTestId={`toggle-button-${opt.value}`}
            isPill={rest.isPill ?? false}
          />
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}

export default FormToggleGroup;
